var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdvancedMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 484,
    viewBox: "0 0 375 484",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4604_24655)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_4604_24655",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H375V484H0V0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H375V484H0V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.793 1.95668C338.588 2.68874 342 6.90148 342 11.7521V87.9165L395.866 34.0504C399.297 30.6201 404.689 30.0539 408.596 32.929C415.449 37.9709 422.008 43.5919 428.208 49.7918C434.408 55.9918 440.029 62.5515 445.071 69.4038C447.946 73.3112 447.38 78.7033 443.95 82.1336L390.083 136H466.248C471.099 136 475.311 139.412 476.043 144.207C477.336 152.674 477.988 161.219 478 169.766C478 169.922 478 170.078 478 170.234C477.988 178.781 477.336 187.327 476.043 195.793C475.311 200.588 471.099 204 466.248 204H390.083L443.949 257.867C447.38 261.297 447.946 266.689 445.071 270.597C440.029 277.449 434.408 284.008 428.208 290.208C422.008 296.408 415.448 302.029 408.596 307.071C404.689 309.946 399.296 309.38 395.866 305.95L342 252.084V328.248C342 333.099 338.589 337.311 333.793 338.043C325.35 339.332 316.829 339.984 308.306 340C308.102 340 307.898 340 307.694 340C299.172 339.984 290.65 339.332 282.207 338.043C277.412 337.311 274 333.099 274 328.248V252.083L220.134 305.95C216.703 309.38 211.311 309.946 207.404 307.071C200.552 302.029 193.992 296.408 187.792 290.208C181.592 284.008 175.971 277.448 170.929 270.596C168.054 266.689 168.62 261.297 172.05 257.866L225.917 204H149.752C144.901 204 140.689 200.588 139.957 195.793C137.348 178.705 137.348 161.295 139.957 144.207C140.689 139.412 144.901 136 149.752 136H225.916L172.05 82.1339C168.62 78.7037 168.054 73.3115 170.929 69.4041C175.971 62.5517 181.592 55.9919 187.792 49.7918C193.992 43.592 200.551 37.9711 207.403 32.9292C211.311 30.0541 216.703 30.6203 220.133 34.0506L274 87.9176V11.752C274 6.90138 277.412 2.68864 282.207 1.95659C299.296 -0.652226 316.705 -0.652199 333.793 1.95668Z",
    fill: "url(#paint0_linear_4604_24655)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_f_4604_24655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.826 452.812C358.166 384.801 348.009 436.569 410.297 505.081C433.973 531.125 389.387 584.312 347.517 659.289C329.986 690.682 135.303 764.151 75.4084 762.801C-113.47 758.543 8.53622 697.798 7.92532 672.627C7.31442 647.455 115.486 520.823 236.826 452.812Z",
    fill: "#11AB7D"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M375 483H0V485H375V483Z",
    fill: "black",
    fillOpacity: 0.15,
    mask: "url(#path-1-inside-1_4604_24655)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4604_24655",
    x: -530.28,
    y: -79.09,
    width: 1447.17,
    height: 1341.91,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 250,
    result: "effect1_foregroundBlur_4604_24655"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4604_24655",
    x1: 425.93,
    y1: 45.0726,
    x2: 201.801,
    y2: 269.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11AB7D",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11AB7D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4604_24655"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H375V484H0V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvancedMobile);
export default __webpack_public_path__ + "static/media/advanced-mobile.72b833020abc7153a2b7bf41b4be5a6d.svg";
export { ForwardRef as ReactComponent };